import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import noop from 'lodash/noop';

import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import { IconButton } from '@atlaskit/button/new';
import ShowMoreHorizontalIcon from '@atlaskit/icon/utility/migration/show-more-horizontal--editor-more';
import { Text } from '@atlaskit/primitives';

const i18n = defineMessages({
	viewPermissions: {
		id: 'default-space-permissions.table.custom-roles-menu.view-permissions',
		defaultMessage: 'View permissions',
		description: 'Option in Custom Roles Menu to view the permissions of the role',
	},
	editRole: {
		id: 'default-space-permissions.table.custom-roles-menu.edit-role',
		defaultMessage: 'Edit custom role',
		description: 'Option in Custom Roles Menu to edit a set of role permissions and details',
	},
	deleteRole: {
		id: 'default-space-permissions.table.custom-roles-menu.delete-role',
		defaultMessage: 'Delete custom role',
		description: 'Option in Custom Roles Menu to delete a custom role',
	},
});

export const CustomRolesMenu = () => {
	const { formatMessage } = useIntl();
	return (
		<DropdownMenu<HTMLButtonElement>
			trigger={({ triggerRef, ...props }) => (
				<IconButton
					{...props}
					icon={ShowMoreHorizontalIcon}
					label="more"
					ref={triggerRef}
					testId="table-actions-menu"
				/>
			)}
			shouldRenderToParent
		>
			<DropdownItemGroup>
				<DropdownItem onClick={noop}>{formatMessage(i18n.viewPermissions)}</DropdownItem>
				<DropdownItem onClick={noop}>{formatMessage(i18n.editRole)}</DropdownItem>
				<DropdownItem onClick={noop}>
					<Text color="color.text.accent.red">{formatMessage(i18n.deleteRole)}</Text>
				</DropdownItem>
			</DropdownItemGroup>
		</DropdownMenu>
	);
};
